import React, {useState } from "react";
import DataTable, { DataTableQueryParams } from "../../../components/DataTable";
import axiosApi from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import VerifyRow from "./models/VerifyRow";
import SearchResponses from "../../../Models/APIGetData/SearchResponses";
import mapFilter from "./util/mapFilter";
import useGetCertificationStatuses from "../../../http/audit/useGetCertificationStatuses";
import VerifySummary from "../../../Models/Verify/VerifySummary";
import { VerifyUrls } from "../index";
import ContentPage from "../../../components/ContentPage";
import { getCompanyId, getUserEmail, getUserId, isCBCommercialHorizonUser, isCBUser, isMegatronCompanyUser, isMegatronFeatureOn, isMegatronLiteUser, isMegatronProUser } from "../../../Authentication/Auth";
import useCountries from "../../../http/verify/useGetCountry";
import sortNameAlphanumerical from "../../../util/sorting/sortNameAlphanumerical";
import SimpleMenu from "../../../components/VerifyReportManagement/Index"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTableInputs } from "../../../store/details/actions/getTableFilterInputs";
import { useSelector } from "react-redux";
import TableInputFilter from "../../../Models/common/TableInputFilter";
import { RootState } from "../../../store/reducers";
import clsx from "clsx";
import CertificationStatus from "../../../Models/common/CertificationStatus";
import { upgradeAPILink, upgradeToMoreFavouritesLink, upgradeToProLink } from "../../../components/Paths/paths";
import VerifyTable from "./util/verifyColumns";
import styles from './verify-search.module.scss'
const VerifySearchTable = () => {
  const history = useHistory()
  const dispatch=useDispatch()
  const inpuFilterFetchStore: TableInputFilter = useSelector(
      (state: RootState) => state.details.tableFilterInputs
    );
  interface LocationState{backClick?:boolean}
  let backNavigation=(history.location.state as LocationState)?.backClick

if(history.action=="POP")
{
  backNavigation=false
  
}
 
  const [reportfilter, setreportfilter] = useState<
    (DataTableQueryParams)
  >();

  const [isMegatronFetaureOn, setisMegatronFetaureOn] = useState<boolean>(false);
  
    const fetchisMegatronFetaureOn = async () => {
          const megatronFeature = await isMegatronFeatureOn();
          setisMegatronFetaureOn(megatronFeature);
        };
    
        fetchisMegatronFetaureOn();
  
    const megatronProUser = getUserId() != undefined && isMegatronProUser() && isMegatronFetaureOn;
    const megatronLiteUser = getUserId() != undefined && isMegatronLiteUser() && isMegatronFetaureOn;
  const megatronUser = getUserId() != undefined && isMegatronCompanyUser() && isMegatronFetaureOn
   const standardsFilter  ={
    "Agents and Brokers": "Agents and Brokers",
    "Consumer Products": "Consumer Products",
    "ETRS": "ETRS",
    "Food": "Food",
    "Gluten-Free": "Gluten-Free",
    "Packaging Materials": "Packaging Materials",
    "Plant Based": "Plant Based",
    "START!": "START!",
    "Storage and Distribution": "Storage and Distribution",
     };
const gradeFilter={
"AA+": "AA+",
"AA": "AA",
"A+": "A+",
"A": "A",
"B+": "B+",
"B":"B",
"C+":"C+",
"C":"C",
"D+":"D+",
"D": "D",
"Foundation +": "Foundation +",
"Foundation": "Foundation",
"No Grade": "No Grade"
}


const countryFilter  = mapFilter(useCountries().siteCountries.sort(sortNameAlphanumerical));


const status = useGetCertificationStatuses().certificationStatuses.sort(sortNameAlphanumerical);
const statusCertificatedFiltered = status.find(item => item.name == "Certificated");
 const certificationFilter = (isCBUser() || isCBCommercialHorizonUser() || isMegatronLiteUser()) ? mapFilter(
   [{id:statusCertificatedFiltered?.id??0, name:statusCertificatedFiltered?.name??""}]
 ) : mapFilter(status);

   interface DataTableQueryParams {
    readonly pageNumber: number;
    readonly orderBy?: string | number | symbol;
    readonly order: "asc" | "desc";
    readonly searchTerm: string;
    readonly [key: string]: string | string[] | number | symbol | undefined | boolean;
  
  }
 
  const fetch = (
        params: DataTableQueryParams,
        
        
  ): Promise<{ data: VerifyRow[]; totalPages: number }> => {
    setreportfilter(params);

    if(backNavigation==false||backNavigation == undefined) 
     {
     dispatch(setTableInputs(params))
    
     }
   
    return axiosApi
      .get<SearchResponses<VerifySummary>>(BackendServices.AUDIT_SERVICE.VERIFY, {
      
       params: (backNavigation == false||backNavigation == undefined) ? params : inpuFilterFetchStore
      }
      )
      .then(({ data }) => ({
        totalPages: data.totalPages,
        data: data.resultsList.map(
          (audit): VerifyRow => ({
            Id: audit.id.toString(),
            SiteName: audit.site.name,
            SiteId: audit.site.id,
            CertificationBody: audit.certificationBody.name,
            ProgramOwner: audit.programOwner,
            Standard: audit.standard.name,
            AuditOwner: audit.auditOwner,
            ExpiryDate:audit.expiryDate,
            IssueDate:audit.issueDate,
            CertificationStatus: audit.certificationStatus,
            AuditStatus: audit.auditStatus,
            Grade:audit.grade,
            Country:audit.country,
            City:audit.city,
            IsFavourited:audit.isFavourited,
            SharingPermissionName:audit.sharingPermissionName,
            HasCertificate:audit.hasCertificate,
              
          })
        
        ),
      }
     
        )
      
      )
      .finally(() =>
       {
           history.location.state={"backClick":false}
       }
    );
      ;
     
  };
   const upgradeToProClick = () => {
    var redirectURL = `${upgradeToProLink}?companyId=${getCompanyId()}&email=${getUserEmail()}`
      window.open(redirectURL, "_blank");
    };

   const upgradeToMoreFavouritesClick = () => {
    const redirectURL = `${upgradeToMoreFavouritesLink}?companyid=${getCompanyId()}&email=${getUserEmail()}`
    window.open(redirectURL, "_blank");
   }

   const upgradeAPIClick = () => {
    const redirectURL = `${upgradeAPILink}?companyid=${getCompanyId()}&email=${getUserEmail()}`
    window.open(redirectURL, "_blank");
   }
 
 
  const result = typeof VerifyTable(megatronProUser)
 
  return (
    <ContentPage title="Certificate Tracker">
      <div
        className={styles.buttonContainer}
      > 
         {megatronLiteUser && <button type="button"  onClick={() => upgradeToProClick()} className="btn-upgrade-to-pro">     
          Upgrade to Pro
        </button>}
         {megatronProUser && <div className={styles.buttonDiv}>
        <button type="button" onClick={() => upgradeAPIClick()} className="btn-upgrade-to-pro" style={{width: '220px'}}>API Upgrade</button>
         <button type="button"  onClick={() => upgradeToMoreFavouritesClick()} className="btn-upgrade-to-pro">     
          Upgrade Favourites
        </button>
        </div>}
      </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: 40,
          }}
        > 
        </div>

      <DataTable<VerifyRow>
        columns={VerifyTable(megatronLiteUser)}
        fetchRemoteData={fetch}
        filters={{
          Standard: () => standardsFilter,
          Country: () => countryFilter,
          CertificationStatus: () => certificationFilter,
          Grade: () => gradeFilter,
        }}
        rowActions={undefined}
        toolBarOptions={{
          newEntityLink: !isCBUser()
            ? {
                label: "Add new audit",
                link: VerifyUrls.create(),
              }
            : undefined,
        }}
        favouriteFilter={{ enabled: (isCBUser() || isCBCommercialHorizonUser()) ? false : true }}
        isMegatronLite={megatronLiteUser}
        reportFilter={reportfilter}
        enableExportButton={(isCBUser() || isCBCommercialHorizonUser()) ? false : true}
      />
    </ContentPage>
  );
};

export default VerifySearchTable;
